import React from 'react'
import Sidebar from '../Components/SidebarDashboard'

const LayoutDashboard = (props) => {
  return (
    <>
<main className="relative h-screen overflow-hidden bg-gray-100 dark:bg-gray-800">
  <div className="flex items-start justify-between">
    <Sidebar/>
    <div className="flex flex-col w-full md:space-y-4">
      <header className="z-40 flex items-center justify-between w-full h-16">
        <div className="block ml-6 lg:hidden">
          <div className="flex items-center p-2 text-gray-500 bg-white rounded-full shadow text-md">
            <svg
              width={20}
              height={20}
              className="text-gray-400"
              fill="currentColor"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path>
            </svg>
          </div>
        </div>
        <div className="relative z-20 flex flex-col justify-end h-full px-3 md:w-full">
            {/* Header */}
        </div>
      </header>
      <div className="h-screen px-4 pb-24 overflow-auto md:px-6">
        {/* Biki disini */}
        {props.children}
      </div>
    </div>
  </div>
</main>

    </>
  )
}

export default LayoutDashboard